export default __webpack_public_path__ + "static/media/success-logo.4f261545.svg";